import type { HotelConstraint } from '@libs/constraint-builder';
import {
  deserializeConstraint,
  HotelCodeConstraint,
  PolygonIdConstraint,
} from '@libs/constraint-builder';
import { exhaustiveGuard } from '@libs/utils';
import type {
  SearchTerm,
  HotelConstraintSelectionQL,
} from '@libs/trip-planner-interfaces';
import { SearchTermType } from '@libs/trip-planner-interfaces';

export function getBaseConstraint(searchTerm: SearchTerm): HotelConstraint {
  switch (searchTerm.type) {
    case SearchTermType.HotelCode:
      return { selection: new HotelCodeConstraint(searchTerm.hotelCode) };
    case SearchTermType.PolygonId:
      return { selection: new PolygonIdConstraint(searchTerm.polygonId) };
    case SearchTermType.FreeText:
      return deserializeConstraint(searchTerm.freeText);
    default:
      exhaustiveGuard(searchTerm, 'Invalid searchTerm type');
  }
}

export function getBaseConstraintQL(
  searchTerm: SearchTerm
): HotelConstraintSelectionQL {
  switch (searchTerm.type) {
    case SearchTermType.HotelCode:
      return { hotelCodes: [searchTerm.hotelCode] };
    case SearchTermType.PolygonId:
      return { polygonId: searchTerm.polygonId };
    case SearchTermType.FreeText:
      return { destination: searchTerm.freeText };
    default:
      exhaustiveGuard(searchTerm, 'Invalid searchTerm type');
  }
}
